import { ActivityDetailApiElementContentModel } from '@/services/platform/api/model';
import { cn, ModuleProperties } from '@/lib/core';
import ModuleWrapper from '@/components/shared/module/wrapper';
import { ProfileActivityDetail } from '@/components/shared/profile/activity/detail';

export const ActivityDetailAPI = (props: ModuleProperties) => {
  const content = props.content as ActivityDetailApiElementContentModel | undefined;
  if (!content) return null;

  return (
    <ModuleWrapper
      component={props}
      classNames={{
        base: cn(['module__activity-detail']),
        container: cn(['flex-1']),
        wrapper: cn(['py-0', 'flex-1']),
        grid: cn(['flex flex-col flex-1 gap-0']),
      }}
      isFullWidth={true}
      {...props}
    >
      <ProfileActivityDetail />
    </ModuleWrapper>
  );
};
